import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, NavLink } from 'react-router-dom';
import Logo from './../assets/img/logo.svg';


function UserSideNavbar(props) {
    const { t } = useTranslation();

    const handleLangChange = () => {
        props.onChangeHandleMenu();
    }


    return (
        <>
            <aside id="layout-menu" className="layout-menu menu-vertical menu bg-menu-theme align-self-start sticky-top" style={{"position": "sticky","height": "100vh"}}>
                <div className="app-brand demo mt-3 mb-3">
                    <Link to="/dashboard" className="app-brand-link">
                        <img src={Logo} alt='Staff Hisab' style={{ "width": '100%' }} />
                    </Link>

                    <Link onClick={handleLangChange} to="#"
                        className="layout-menu-toggle menu-link text-large ms-auto d-block d-xl-none">
                        <i className="bx bx-chevron-left bx-sm align-middle"></i>
                    </Link>
                </div>

                <div className="menu-inner-shadow"></div>

                <ul className="menu-inner py-1 overflow-auto">
                    <li className="menu-item">
                        <NavLink exact="true" to="/dashboard" className="menu-link" onClick={handleLangChange}>
                            <i className="menu-icon tf-icons bx bx-home-circle"></i>
                            <div data-i18n="Email">{t('sideMenu.dashboards')}</div>
                        </NavLink>
                    </li>
                    <li className="menu-item">
                        <NavLink exact="true" to="/employees" className="menu-link" onClick={handleLangChange}>
                            <i className="menu-icon tf-icons  bx bx-user-plus "></i>
                            <div data-i18n="Email">{t('sideMenu.employees')}</div>
                        </NavLink>
                    </li>
                    <li className="menu-item">
                        <NavLink exact="true" to="/departments" className="menu-link" onClick={handleLangChange}>
                            <i className="menu-icon tf-icons  bx bxs-bank "></i>
                            <div data-i18n="Email">{t('sideMenu.departments')}</div>
                        </NavLink>
                    </li>
                    <li className="menu-item">
                        <NavLink exact="true" to="/units" className="menu-link" onClick={handleLangChange}>
                            <i className="menu-icon tf-icons bx bxs-factory "></i>
                            <div data-i18n="Email">{t('sideMenu.units')}</div>
                        </NavLink>
                    </li>


                    <li className="menu-item">
                        <NavLink exact="true" to="/attendance" className="menu-link" onClick={handleLangChange}>
                            <i className="menu-icon tf-icons bx bx-time-five "></i>
                            <div>{t('sideMenu.attendance')}</div>
                        </NavLink>
                    </li>
                    <li className="menu-item">
                        <NavLink exact="true" to="/payments" className="menu-link" onClick={handleLangChange}>
                            <i className="menu-icon tf-icons bx bx-rupee"></i>
                            <div>{t('sideMenu.payments')}</div>
                        </NavLink>
                    </li>
                

                    <li className="menu-item">
                        <Link href="#" className="menu-link menu-toggle collapsed" data-bs-toggle="collapse" data-bs-target="#navbarToggleReports">
                            <i className="menu-icon tf-icons bx bxs-report"></i>
                            <div data-i18n="Dashboards">{t('sideMenu.reports')}</div>
                        </Link>
                        <ul className="menu-sub collapse" id="navbarToggleReports">
                            <li className="menu-item">
                                <NavLink to="/reports/salary" className="menu-link" end onClick={handleLangChange}>
                                    <div>{t('sideMenu.salaryReports')}</div>
                                </NavLink>
                            </li>
                            <li className="menu-item">
                                <NavLink to="/reports/payroll" className="menu-link" end onClick={handleLangChange}>
                                    <div>{t('sideMenu.payrollSummaryReport')}</div>
                                </NavLink>
                            </li>
                            <li className="menu-item">
                                <NavLink to="/reports/employee-laser" className="menu-link" onClick={handleLangChange}>
                                    <div>{t('sideMenu.employeeLaserReports')}</div>
                                </NavLink>
                            </li>
                            <li className="menu-item">
                                <NavLink to="/reports/laser" className="menu-link" onClick={handleLangChange}>
                                    <div>{t('sideMenu.laserReports')}</div>
                                </NavLink>
                            </li>
                        </ul>
                    </li>

                    <li className="menu-item">
                        <Link href="#" className="menu-link menu-toggle collapsed" data-bs-toggle="collapse" data-bs-target="#navbarToggleUsers">
                            <i className="menu-icon tf-icons bx bx-user"></i>
                            <div data-i18n="Dashboards">{t('sideMenu.profile')}</div>
                        </Link>
                        <ul className="menu-sub collapse" id="navbarToggleUsers">
                            <li className="menu-item">
                                <NavLink to="/profile" className="menu-link" end onClick={handleLangChange}>
                                    <div>{t('sideMenu.myProfile')}</div>
                                </NavLink>
                            </li>
                            <li className="menu-item">
                                <NavLink to="/profile/my-subscription" className="menu-link" onClick={handleLangChange}>
                                    <div>{t('sideMenu.mySubscription')}</div>
                                </NavLink>
                            </li>
                            <li className="menu-item">
                                <NavLink to="/profile/invoices" className="menu-link" onClick={handleLangChange}>
                                    <div>{t('sideMenu.invoices')}</div>
                                </NavLink>
                            </li>
                            <li className="menu-item">
                                <NavLink to="/profile/setting" className="menu-link" onClick={handleLangChange}>
                                    <div>{t('sideMenu.setting')}</div>
                                </NavLink>
                            </li>
                        </ul>
                    </li>

                    <li className="menu-item">
                        <NavLink exact="true" to="/upgrade-plan" className="menu-link" onClick={handleLangChange}>
                            <i class='menu-icon tf-icons bx bxs-plane-alt'></i>
                            <div>{t('sideMenu.upgradePlan')}</div>
                        </NavLink>
                    </li>
                    
                    <li className="menu-item">
                        <NavLink exact="true" to="/support" className="menu-link" onClick={handleLangChange}>
                            <i className="menu-icon tf-icons bx bx-support "></i>
                            <div>{t('sideMenu.support')}</div>
                        </NavLink>
                    </li>
                    <li className="menu-item">
                        <a exact="true" href="https://www.youtube.com/watch?v=TNYjxA8zc9g" target="_blank" rel="noreferrer" className="menu-link">
                            <i className="menu-icon tf-icons bx bxl-youtube "></i>
                            <div>{t('sideMenu.demoVideo')}</div>
                        </a>
                    </li>
                </ul>
                <span className='web-v'>V {localStorage.getItem("app_version") || '0.0.0'}</span>
            </aside>
        </>
    );
}

export default UserSideNavbar;